module.exports = __webpack_public_path__ + "img/House4_Desktop-mobile.5288e9d9.jpg";